import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/supplierDetails'
import Component from 'components/SupplierDetails'

export default createListViewContainer({ actions, selectors: selectors.supplierDetails })(Component)
